// extracted by mini-css-extract-plugin
export default {"page":"ProfilePage_page__Uh51q","content":"ProfilePage_content__NEjPh","left_column":"ProfilePage_left_column__T-QqG","center_column":"ProfilePage_center_column__qlPo2"};